module.exports = __webpack_public_path__ + "img/g6.5bbb186b.jpg";